import { CollectClient } from "@tree-company/collect-js-client";

let collectorURL = import.meta.env.VITE_COLLECTOR_URL;
if (import.meta.env.DEV && collectorURL === undefined) {
  collectorURL = "http://localhost:3000";
}

let aggregatorURL = import.meta.env.VITE_AGGREGATOR_URL;
if (import.meta.env.DEV && aggregatorURL === undefined) {
  aggregatorURL = "http://localhost:3300";
}

// Setup client - we only need to do this once
const client = new CollectClient({
  url: collectorURL,
  projectKey: import.meta.env.VITE_COLLECTOR_KEY,
});

// Create new response for student
const response = client.initTreesponse({ language: "nl" });

export async function updateResponse(answers) {
  response.completed = true;
  response.setAnswers(answers);
  await response.save();
}

export async function fetchResult(code) {
  const response = await fetch(
    `${aggregatorURL}/edubox/war-and-peace/${code}`,
    {
      headers: {
        Authorization: `token ${import.meta.env.VITE_AGGREGATOR_KEY}`,
      },
    },
  );
  return await response.json();
}
